import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('boundaryFormFields');

    return {
        BOUNDARY_NAME_FIELD_PLACEHOLDER: t('boundaryNameFieldPlaceholder')
    };
};

export default useTranslation;
